import { LocationClosureModel,} from "../../entities";
import { BaseDataRepository } from "../BaseDataRepository";

export class LocationClosureRepo extends BaseDataRepository<LocationClosureModel> {
  protected baseUrl = 'locationclosure';

  async addLocationClosureAsync(locationClosure: LocationClosureModel): Promise<LocationClosureModel | null>{
    const response = await this.client.post(`${this.baseUrl}/addclosure`, locationClosure);
    return this.handleResponse<LocationClosureModel>(response);
  }
  async getAllClosuresByLocationIdAsync(locationId: number): Promise<LocationClosureModel[]> {
    const response = await this.client.get(`${this.baseUrl}/getallclosuresbylocationid/${locationId}`);
    return this.handleResponse<LocationClosureModel[]>(response)!;
  }

  async insertClosureAsync(locationClosure: LocationClosureModel): Promise<LocationClosureModel>{
    const response = await this.client.post(`${this.baseUrl}/insertClosure/`, locationClosure);
    return this.handleResponse<LocationClosureModel>(response)!;
  }

}

export default LocationClosureRepo;
